import { partition } from "lodash";
import { useMemo } from "react";
import { useUser } from "src/contexts/user-context";
import { navigateToWorkspaces } from "src/utils/navigate";
import { switchWorkspace } from "src/utils/workspaces";
import { isPresent } from "ts-extras";
import { useNavWidth } from "src/contexts/nav-width-context";
import { NavSelector } from "./nav-selector";

export const WorkspaceSelector = () => {
  const { workspace, workspaces } = useUser();
  const { isNavOpen } = useNavWidth();

  const menuOptions = useMemo(() => {
    const [activeWorkspaces, inactiveWorkspaces] = partition(
      workspaces,
      ({ slug }) => slug === workspace?.slug,
    );
    const activeWorkspace = activeWorkspaces?.[0];
    const orderedWorkspaces = [activeWorkspace]
      .concat(inactiveWorkspaces)
      .filter(isPresent);
    const options = orderedWorkspaces?.map(({ name, id, slug }) => ({
      active: slug === workspace?.slug,
      label: name,
      onClick: () => switchWorkspace(id, `/${slug}`),
    }));
    return options ?? [];
  }, [workspaces, workspace?.slug]);

  return (
    <NavSelector
      ariaLabel="Select workspace"
      displayLabel={workspace?.name ?? "Select workspace"}
      options={menuOptions}
      isNavOpen={isNavOpen}
      height={10}
      topAction={{
        label: "View all workspaces",
        onClick: navigateToWorkspaces,
      }}
      showSearchbar={true}
      searchPlaceholder="Search workspaces"
    />
  );
};
